import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import VisitDto = MdbsCore.VisitDto;
import IVisitCreateDto = MdbsCore.IVisitCreateDto;
import IVisitUpdateDto = MdbsCore.IVisitUpdateDto;
import VisitUpdateDto = MdbsCore.VisitUpdateDto;
import VisitCreateDto = MdbsCore.VisitCreateDto;
import IVisitSignatureDto = MdbsCore.IVisitSignatureDto;
import VisitSignatureDto = MdbsCore.VisitSignatureDto;
import VisitSignatureResult = MdbsCore.VisitSignatureResult;
import IVisitSignatureResult = MdbsCore.IVisitSignatureResult;

const visitClient = new MdbsCore.VisitClient();

@Module({namespaced: true, name: 'visit', store: store})
export default class VisitModule extends BaseModule {
    visit: VisitDto = new VisitDto();
    _visitSignatureResult: IVisitSignatureResult = new VisitSignatureResult({success: true, message: ""});

    @Mutation
    setVisit(visit: VisitDto) {
        this.visit = visit;
    }

    @Mutation
    setVisitSignatureResult(visitSignatureResult: IVisitSignatureResult) {
        this._visitSignatureResult = visitSignatureResult;
    }

    @Mutation
    reset() {
        this.visit = new VisitDto();
    }

    @Action({rawError: true})
    async loadById(id: string) {
        await this.execute(async () => this.setVisit(await visitClient.getById(id))
        ).catch(() => this.reset());
    }

    @Action({rawError: true})
    async create(visit: IVisitCreateDto) {
        await this.execute(async () => {
            const createdVisit = await visitClient.create(new VisitCreateDto(visit));
            this.setVisit(createdVisit)
        }).catch();
    }

    @Action({rawError: true})
    async update(visit: IVisitUpdateDto) {
        await this.execute(async () => {
            const updatedVisit = await visitClient.update(visit.id, new VisitUpdateDto(visit));
            this.setVisit(updatedVisit)
        }).catch();
    }

    @Action({rawError: true})
    async delete(id: string) {
        await this.execute(async () => {
            await visitClient.delete(id);
            this.reset()
        }).catch();
    }

    @Action({rawError: true})
    async sign(payload: {visitId: string, signatureData: IVisitSignatureDto}) {
        const {visitId, signatureData} = payload;

        await this.execute(async () => {
            const visitSignatureResult = await visitClient.sign(visitId, new VisitSignatureDto(signatureData));

            this.setVisitSignatureResult(visitSignatureResult);
            this.reset();
        }).catch();
    }

    get visitSignatureResult() {
        return this._visitSignatureResult;
    }
}
